import React from 'react';

import { get } from 'lodash';
import I18n from 'i18n-js';
import CuratedSetRow from './curated_set_row';
import RelatedBrandsRow from '../discovery/related_brands_row';
import { reverb_search_SearchResponse } from '../../schemas/rql';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_types';

function getBrands(filters) {
  const agg = filters.filter(f => f.aggregationName === 'BRAND_SLUGS')[0];

  if (agg) {
    return agg.options.map(o => ({
      name: o.name,
      slug: o.optionValue,
    }));
  }
}

function getCuratedSets(filters) {
  const agg = filters.find(f => f.aggregationName === 'CURATED_SETS');

  if (agg) {
    return agg.options.map(o => o.optionValue);
  }
  return [];
}

interface ExternalProps {
  search?: reverb_search_SearchResponse;
  queryParams: {
    query?: string;
  };
  pageName?: MParticlePageName;
}

export default function FooterRow(props: ExternalProps) {
  if (props.pageName === MParticlePageName.Shop) { return null; }

  return (
    <>
      <RelatedBrandsRow
        brands={getBrands(get(props, 'search.filters', []))}
        heading={I18n.t('discovery.brandCards.relatedBrands')}
      />
      <CuratedSetRow
        showHeading
        centeredTitle
        ids={getCuratedSets(get(props, 'search.filters', []))}
      />
    </>
  );
}
